import {
	API_AWARD,
	API_AWARD_FEED,
	API_AWARD_SUMMARY,
	API_NOTES,
	API_PROJECT,
	DEFAULT_SEARCH_LIMIT,
} from "globals/constants";
import { spUrl } from "utils";
import {
	buildSearchParams,
	patch,
	put,
	remove,
	request,
	save,
} from "utils/proxy";


export const award = {
	create: (body, options) => save(spUrl(`${API_AWARD}/create-or-copy?strict=true`), body, options),

	getAttributes: (searchParams, options) => {
		const params = {
			attributes: searchParams.attributes,
			requiredAttributes: searchParams.requiredAttributes,
			search: searchParams.search,
			size: searchParams.size || DEFAULT_SEARCH_LIMIT,
			page: searchParams.page || 0,
		};

		const url = searchParams.projectId ?
			`${API_PROJECT}/${searchParams.projectId}/awards/attributes${buildSearchParams(params)}` :
			`${API_AWARD}/attributes${buildSearchParams(params)}`;

		return request(spUrl(url), options);
	},

	/**
	 * @param {string} id
	 * @param {{}?} options
	 */
	get: (id, options) => request(spUrl(`${API_AWARD}/${id}`), options),

	find: (searchParams, options) =>
		request(spUrl(`${API_AWARD_FEED}${buildSearchParams(searchParams)}`), options),

	getValues: (id, searchParams, options) =>
		request(spUrl(`${API_AWARD_FEED}/${id}${buildSearchParams(searchParams)}`), options),

	getReviews: (id, options) => request(spUrl(`${API_AWARD}/${id}/reviews`), options),

	getCertifications: (id, options) => request(spUrl(`${API_AWARD}/${id}/certifications`), options),

	updateCertifications: (params, body, options) =>
		put(spUrl(`${API_AWARD_FEED}/${params.id}/certification`), body, options),

	getSummary: (searchParams = { groupBy: "status" }, options) =>
		request(spUrl(`${API_AWARD_SUMMARY}${buildSearchParams(searchParams)}`), options),

	addDistribution: (awardId, body, options) =>
		save(spUrl(`${API_AWARD}/${awardId}/distributions`), body, options),

	updateDistribution: (awardId, id, body, options) =>
		put(spUrl(`${API_AWARD}/${awardId}/distributions/${id}`), body, options),

	removeDistribution: (awardId, id, options) =>
		remove(spUrl(`${API_AWARD}/${awardId}/distributions/${id}`), options),

	getStatus: (awardId, options) => request(spUrl(`${API_AWARD}/${awardId}/status/flow`), options),
	saveStatus: (awardId, body, options) => save(spUrl(`${API_AWARD}/${awardId}/status`), body, options),
	updateStatus: (awardId, body, options) => put(spUrl(`${API_AWARD}/${awardId}/status`), body, options),

	routeForReview: (params, body, options) => save(spUrl(`${API_AWARD}/${params.id}/route`), body, options),

	/**
	 * @param {{formId}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	updateAdminTeamMember: (params, body, options) =>
		put(spUrl(`${API_AWARD}/${params.formId}/admin-team-members`), body, options),

	/**
	 * @param {{formId}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	updateAccess: (params, body, options) => put(spUrl(`${API_AWARD}/${params.formId}/accesses`), body, options),

	/**
	 * @param {{awardId}} params
	 * @param {*} searchParams
	 * @param {{}?} options
	 */
	getNotes: (params, searchParams, options) =>
		request(spUrl(`${API_NOTES}/awards/${params.awardId}${buildSearchParams(searchParams)}`), options),

	/**
	 * @param {{awardId}} params
	 * @param {{}?} body
	 * @param {{}?} options
	 */
	saveNote: (params, body, options) =>
		save(spUrl(`${API_NOTES}/awards/${params.awardId}`), body, options),

	/**
	 * @param {{awardId, noteId}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	updateNote: (params, body, options) =>
		put(spUrl(`${API_NOTES}/${params.noteId}/awards/${params.awardId}`), body, options),

	/**
	 * @param {{awardId: string, noteId: string}} params
	 * @param {{}?} options
	 */
	deleteNote: (params, options) => remove(spUrl(`${API_NOTES}/${params.noteId}/awards/${params.awardId}`), options),

	/**
	 * @param {{awardId, attachmentId}} params
	 * @param {{}?} options
	 */
	deleteAttachment: (params, options) =>
		remove(spUrl(`${API_NOTES}/awards/${params.awardId}/attachments/${params.attachmentId}`), options),

	/**
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<any>}
	 */
	updateAdminMembers: (body, options) => patch(spUrl(`${API_AWARD}/adminMembers`), body, options),
};
